import awaitToJs from 'await-to-js'
import {
  SET_JOBS_USER,
  ALERT_COLORS,
  MESSAGE_ERROR,
  ALERT_DELAY,
} from '@App/constantes'
import Fetch from '@App/helpers/fetch'
import { setAlertBox } from './snackbar'
import { API_URL } from '@App/configs/rest'

const fetchGetJobsUser = new Fetch()

export const setJobsUser = (jobs: any) => {
  return {
    type: SET_JOBS_USER,
    payload: jobs,
  }
}

export const getJobsUser = () => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(
      fetchGetJobsUser.get({
        url: `${API_URL}/jobs/`,
        params: null,
        headers: {},
      }),
    )

    if (!err && data) {
      dispatch(setJobsUser(data))

      return data
    }

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
  }
}

export const createJob = (name) => {
  return async (dispatch: any) => {
    const [err, data] = await awaitToJs(
      fetchGetJobsUser.post({
        url: `${API_URL}/jobs/`,
        body: { title: name },
        headers: {
          'content-type': 'application/json',
        },
      }),
    )

    if (!err && data) {
      dispatch(getJobsUser())

      return data
    }

    if (err) {
      dispatch(
        setAlertBox({
          title: (err && err.message) || MESSAGE_ERROR,
          background: ALERT_COLORS.red,
          delay: ALERT_DELAY,
        }),
      )

      return err
    }
  }
}
